import { styled } from "goober";
import { mobileMedia } from "../hooks/useIsMobile";

export const KeyboardHint = styled("span")`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  ${mobileMedia} {
    display: none;
  }
`;
